module.exports = __webpack_public_path__ + "static/jumbobg-cb1dd2216821a37d9717e294b4885561.jpg";